import environment from '@utilities/environment';

export const getPrefixedUrl = (path: string) => {
    return environment.isLocal ? environment.baseApiUrl + path : path;
};
